import { Image, Link, Text, View } from '@react-pdf/renderer';
import { S3_URL } from 'constants/index';
import { checkObjHasValues, convertToPng } from 'utils';

const Social = ({ styles, data = [], headerTitle }: any) => {
	return (
		<View style={styles.mainBox}>
			<View style={styles.headingBox}>
				<Text style={styles.heading}>{headerTitle}</Text>
			</View>

			<View style={styles.mainBoxInner}>
				{data?.map((res: any, index: number) => {
					if (checkObjHasValues(res)) {
						return (
							<View key={index} style={styles.detailBox}>
								{res?.image && (
									<View>
										<Image style={styles.detailIcon} src={convertToPng(`${S3_URL}${res?.image}`)} />
									</View>
								)}
								<View style={styles.detailBoxContent}>
									<Text style={styles.detailSubText}>
										<Link style={styles.detailText} src={res?.socialLink}>
											{res?.title}
										</Link>
									</Text>
								</View>
							</View>
						);
					}
				})}
			</View>
		</View>
	);
};

export default Social;
